import React from 'react';

interface StepHeadingProps {
	step: number;
	title: string;
}

export const StepHeading: React.FC<StepHeadingProps> = ({ step, title }) => (
	<div className="cem-step">
		<span className="cem-step__badge">{step}</span>
		<h3 className="cem-step__title">{title}</h3>
	</div>
);

export default StepHeading;
